import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { RelatorioContasReceberRequest } from '../../requests/financas/relatorio-contas-receber.request';
import { SaveRelatorioFiltroFavoritoRequest } from '../../requests/financas/save-relatorio-filtro-favorito.request';
import { SaveRelatorioFiltroFavoritoResponse } from '../../responses/financas/relatorio-filtro-favorito.response';
import {
    RelatorioContasReceberLookupResponse,
    RelatorioContasReceberResponse,
    RelatorioContasReceberBuscarClientesResponse
} from '../../responses/financas/relatorio-contas-receber.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root'
})
export class RelatorioContasReceberService extends CommonService {
    private readonly apiUrl = `${environment.urlApiFinancas}RelatorioContasReceber`;

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getLookup(): Observable<RelatorioContasReceberLookupResponse> {
        return this.httpClient
            .get<RelatorioContasReceberLookupResponse>(`${this.apiUrl}/lookup`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public buscarClientes(q: string): Observable<RelatorioContasReceberBuscarClientesResponse> {
        return this.httpClient
            .get<RelatorioContasReceberBuscarClientesResponse>(`${this.apiUrl}/buscar-clientes?q=${encodeURIComponent(q)}`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getPreview(request: RelatorioContasReceberRequest): Observable<RelatorioContasReceberResponse> {
        return this.httpClient
            .post<RelatorioContasReceberResponse>(`${this.apiUrl}/preview`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public saveFavorito(request: SaveRelatorioFiltroFavoritoRequest): Observable<SaveRelatorioFiltroFavoritoResponse> {
        return this.httpClient
            .post<SaveRelatorioFiltroFavoritoResponse>(`${this.apiUrl}/favorito`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteFavorito(idRelatorioFiltroFavorito: number): Observable<ReturnStruct> {
        return this.httpClient
            .delete<ReturnStruct>(`${this.apiUrl}/favorito/${idRelatorioFiltroFavorito}`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
